import { useState } from 'react';
import './App.css';
import './assets/css/styles.css'; // または import './App.css';

const menuItems = [
  {
    key: 'home',
    label: '利用申請',
    content: (
      <>
        <h2>AIツール利用申請書 (イエロー情報)</h2>
        <table>
            <tbody> 
            <tr>
              <td className="section-title">申請日</td>
              <td>年 月 日</td>
            </tr>
            <tr>
              <td className="section-title">申請者</td>
              <td>所属 ( ) 氏名 ( )</td>
            </tr>
            <tr>
              <td className="section-title">【1】利用するAIツール</td>
              <td>Claude Code □ その他 ( )</td>
            </tr>
            <tr>
              <td className="section-title">【2】利用目的</td>
              <td>(具体的に記載してください)</td>
            </tr>
            <tr>
              <td className="section-title">【3】入力するデータの概要</td>
              <td>(個人情報・NDA情報が含まれていないことを確認の上、入力データの種類と内容を記載してください)</td>
            </tr>
            <tr>
              <td className="section-title">【4】匿名化・マスキング処理の有無</td>
              <td>
                実施済み 処理の内容:( )<br/>
                不要 (個人情報を含まないため)
              </td>
            </tr>
            <tr>
              <td className="section-title">【5】AIの出力の利用範囲</td>
              <td>
                社内検討資料のみ<br/>
                社内の特定部門への共有 (共有先: )<br/>
                社外への提出・公表を検討中 (詳細: )
              </td>
            </tr>
            <tr>
              <td className="section-title">【6】想定される利用期間</td>
              <td>年 月 日 ～ 年 月 日</td>
            </tr>
            <tr>
              <td className="section-title">【7】申請者確認欄</td>
              <td>
                「入力する情報にレッド分類の情報が含まれていないことを確認しました」<br/>
                署名:( )
              </td>
            </tr>
            </tbody>
          </table>

          <h3>承認欄</h3>
          <table>
            <tbody>
            <tr>
              <td className="section-title">【第一承認】直属上長</td>
              <td>
                承認 / 差戻し (理由: )<br/>
                承認日: 年 月 日<br/>
                署名:( )
              </td>
            </tr>
            <tr>
              <td className="section-title">【第二承認】情報セキュリティ管理者/部門長</td>
              <td>
                承認 / 差戻し (理由: )<br/>
                承認日: 年 月 日<br/>
                署名:( )
              </td>
            </tr>
            </tbody>
          </table>

          <h3>申請書の保管</h3>
          <p>
          承認後は申請者・承認者の各自で1年間保管し、監査の際に提出できるよう管理してください。
          </p>

          <h3>緊急時の暫定承認ルール</h3>
          <p>
          通常の承認フローを踏む時間がない緊急対応が必要な場合は、口頭またはメッセージアプリで直属上長の暫定承認を取得した上で入力を開始し、事後24時間以内に書面申請を提出してください。
          </p>
    </>
    ),
  },
  {
    key: 'about',
    label: 'ガバナンス承認',
    content: (
    <>
      <h2>AIガバナンス承認体制</h2>

      <h3>部門レベル (部長・課長・マネージャー)</h3>
      <ul>
        <li>イエロー情報を使ったAI利用の承認</li>
        <li>新しいAIユースケースの部門内導入</li>
        <li>AIツールの試験的利用 (パイロット運用) の承認</li>
        <li>部門長は四半期に一度、AI利用状況をCAIOまたは情報セキュリティ管理者に報告</li>
      </ul>

      <h3>経営レベル (取締役・経営会議)</h3>
      <ul>
        <li>レッド情報の例外的な利用 (事業上やむを得ない場合の特例承認)</li>
        <li>全社ポリシーの変更</li>
        <li>月間AI関連コストが予算の120%を超えた場合の対応</li>
        <li>重大インシデント (情報漏洩など) への対応</li>
        <li>新たなAIツールの全社導入承認</li>
      </ul>

      <p>
        この3階層構造により、日常業務のAI活用を妨げることなく、リスクの高い判断については適切なレベルで意思決定が行われる体制を構築できます。
      </p>

      <h2>監査体制と定期レビュー</h2>
      <p>
        AI利用に関する内部監査は、四半期ごとの実施を推奨します。監査の主な確認事項を以下のチェックリストで示します。
      </p>

      <h3>【チェックリスト】 AIガバナンス監査</h3>

      <table>
        <tbody>
          <tr>
            <th colSpan="2" className="section-title">【A】ポリシー遵守状況の確認</th>
          </tr>
          <tr><td>AI利用ポリシーが全社員に周知されているか</td><td>Yes / No / 要改善</td></tr>
          <tr><td>過去四半期にイエロー申請書が適切に提出・保管されているか</td><td>Yes / No / 要改善</td></tr>
          <tr><td>レッド情報の無断入力事例が報告されていないか</td><td>Yes / No / 要改善</td></tr>
          <tr><td>新入社員・異動者がセキュリティ研修を受講しているか</td><td>Yes / No / 要改善</td></tr>

          <tr>
            <th colSpan="2" className="section-title">【B】利用状況・コストの確認</th>
          </tr>
          <tr><td>APIの利用量が予算内に収まっているか</td><td>Yes / No / 要改善</td></tr>
          <tr><td>部門別の利用状況レポートを取得・確認しているか</td><td>Yes / No / 要改善</td></tr>
          <tr><td>不審な利用パターン (深夜の大量入力など) がないか</td><td>Yes / No / 要改善</td></tr>
          <tr><td>未承認のAIツールが使用されていないか</td><td>Yes / No / 要改善</td></tr>

          <tr>
            <th colSpan="2" className="section-title">【C】技術的セキュリティ対策の確認</th>
          </tr>
          <tr><td>APIキーが適切に管理 (部門別分割、上限設定) されているか</td><td>Yes / No / 要改善</td></tr>
          <tr><td>APIキーのローテーションが予定通り実施されているか</td><td>Yes / No / 要改善</td></tr>
          <tr><td>APIキーがコード等に直書きされていないか</td><td>Yes / No / 要改善</td></tr>

          <tr>
            <th colSpan="2" className="section-title">【D】インシデント管理の確認</th>
          </tr>
          <tr><td>過去四半期のインシデント件数と対応結果を把握しているか</td><td>Yes / No / 要改善</td></tr>
          <tr><td>インシデント対応フローが最新の状態に保たれているか</td><td>Yes / No / 要改善</td></tr>
          <tr><td>インシデント連絡先 (担当者) が最新であるか</td><td>Yes / No / 要改善</td></tr>

          <tr>
            <th colSpan="2" className="section-title">【E】法規制対応の確認</th>
          </tr>
          <tr><td>過去四半期の法規制動向変化を把握しているか</td><td>Yes / No / 要改善</td></tr>
          <tr><td>プライバシーポリシーがAI利用の実態に合致しているか</td><td>Yes / No / 要改善</td></tr>
          <tr><td>業種固有の規制 (金融、医療など) への対応が適切か</td><td>Yes / No / 要改善</td></tr>
        </tbody>
      </table>
      </>
    ),
  },
  {
    key: 'services',
    label: '分類ルール',
    content: (
      <>
  <h2>AI入力情報分類ルール</h2>

      <table>
        <thead>
          <tr>
            <th>分類</th>
            <th>内容</th>
          </tr>
        </thead>
        <tbody>
          <tr className="green">
            <td>グリーン (AI入力可・申請不要)</td>
            <td>
              公開情報、または社内で広く共有されている一般的な業務文書。<br />
              個人情報・NDA対象情報・未公開財務情報を含まないもの。
            </td>
          </tr>
          <tr className="yellow">
            <td>イエロー (AI入力可・上長承認要)</td>
            <td>
              社外秘ではあるが個人情報を含まない社内文書、または匿名化処理が適切に施されたデータ。<br />
              利用目的が業務上明確であり、承認を得た上で入力する。
            </td>
          </tr>
          <tr className="red">
            <td>レッド (AI入力原則禁止)</td>
            <td>
              個人情報、NDA対象情報、未公開財務情報、人事情報、特許申請前の技術情報。<br />
              原則として入力禁止。例外的な利用は経営レベルの承認を要する。
            </td>
          </tr>
        </tbody>
      </table>

      <table className="info-table">
        <thead>
          <tr>
            <th>情報種別</th>
            <th>具体的な情報の例</th>
            <th>分類</th>
            <th>備考</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>顧客データ</td>
            <td>顧客の氏名・住所・連絡先</td>
            <td>レッド</td>
            <td>個人情報に該当</td>
          </tr>
          <tr>
            <td>顧客データ</td>
            <td>顧客IDのみ(氏名なし)</td>
            <td>イエロー</td>
            <td>照合可能性を確認の上</td>
          </tr>
          <tr>
            <td>顧客データ</td>
            <td>匿名化済み購買傾向の集計</td>
            <td>グリーン</td>
            <td>個人識別不能であること</td>
          </tr>
          <tr>
            <td>財務データ</td>
            <td>未公開の決算数値・予算</td>
            <td>レッド</td>
            <td>未公開財務情報</td>
          </tr>
          <tr>
            <td>財務データ</td>
            <td>公開済みの決算短信・有報</td>
            <td>グリーン</td>
            <td>公開情報</td>
          </tr>
          <tr>
            <td>人事データ</td>
            <td>部門別コスト集計 (社内)</td>
            <td>イエロー</td>
            <td>社外秘だが個人情報なし</td>
          </tr>
          <tr>
            <td>人事データ</td>
            <td>社員の氏名・給与・評価</td>
            <td>レッド</td>
            <td>個人情報・人事情報</td>
          </tr>
          <tr>
            <td>人事データ</td>
            <td>部署別人員数・離職率</td>
            <td>イエロー</td>
            <td>個人特定不能な集計値</td>
          </tr>
          <tr>
            <td>人事データ</td>
            <td>組織図 (公開版)</td>
            <td>グリーン</td>
            <td>社外公開されている場合</td>
          </tr>
          <tr>
            <td>技術情報</td>
            <td>特許申請前の設計図・仕様</td>
            <td>レッド</td>
            <td>知的財産・NDA対象</td>
          </tr>
          <tr>
            <td>技術情報</td>
            <td>公開済みの技術文書・マニュアル</td>
            <td>グリーン</td>
            <td>公開情報</td>
          </tr>
          <tr>
            <td>技術情報</td>
            <td>社内システム設計書(秘密指定なし)</td>
            <td>イエロー</td>
            <td>社外秘だが情報保護が限定的</td>
          </tr>
          <tr>
            <td>営業情報</td>
            <td>NDA締結先との交渉内容</td>
            <td>レッド</td>
            <td>NDA対象</td>
          </tr>
          <tr>
            <td>営業情報</td>
            <td>自社の営業戦略・施策案</td>
            <td>イエロー</td>
            <td>社外秘</td>
          </tr>
          <tr>
            <td>営業情報</td>
            <td>業界の市場規模データ (公開)</td>
            <td>グリーン</td>
            <td>公開情報</td>
          </tr>
          <tr>
            <td>契約情報</td>
            <td>NDA・秘密保持条項付き契約書</td>
            <td>レッド</td>
            <td>NDA対象</td>
          </tr>
          <tr>
            <td>契約情報</td>
            <td>標準的な業務委託契約の雛形</td>
            <td>イエロー</td>
            <td>社外秘だが汎用性あり</td>
          </tr>
          <tr>
            <td>契約情報</td>
            <td>公開されている標準約款</td>
            <td>グリーン</td>
            <td>公開情報</td>
          </tr>
        </tbody>
      </table>
      </>
    ),
  },
  {
    key: 'gallery',
    label: '判定フロー',
    content: (
      <>

    <div className="flowchart">
      <div className="box">【START】 この情報をAIに入力してよいか判断したい</div>
      <div className="arrow">↓</div>

      <div className="box">
        Q1: 個人を特定できる要素が含まれていますか？<br />
        (氏名、住所、電話番号、メールアドレス、顧客番号、社員番号など)
      </div>
      <div className="arrow">→ はい</div>
      <div className="box red">
        【レッド:入力禁止】<br />
        個人情報に該当します。匿名化処理を検討してください。
      </div>
      <div className="arrow">→ いいえ ↓</div>

      <div className="box">
        Q2: NDA(秘密保持契約)の対象になっていますか？<br />
        (取引先から受領した情報、NDA締結先との交渉内容など)
      </div>
      <div className="arrow">→ はい</div>
      <div className="box red">
        【レッド:入力禁止】<br />
        取引先に確認なく入力することは契約違反のおそれがあります。
      </div>
      <div className="arrow">→ いいえ ↓</div>

      <div className="box">
        Q3: 未公開の財務情報、人事情報、特許申請前の技術情報が含まれていますか？
      </div>
      <div className="arrow">→ はい</div>
      <div className="box red">
        【レッド:入力禁止】<br />
        経営レベルの承認なく入力することはできません。
      </div>
      <div className="arrow">→ いいえ ↓</div>

      <div className="box">
        Q4: この情報は「社外秘」に分類されていますか？<br />
        (社内限定の戦略文書、部門予算、未公表の新製品情報など)
      </div>
      <div className="arrow">→ はい</div>
      <div className="box yellow">
        【イエロー:上長承認後に入力可】<br />
        イエロー情報利用申請書を提出し、直属上長の承認を得てください。
      </div>
      <div className="arrow">→ いいえ ↓</div>

      <div className="box">
        Q5: この情報は「社外に公開されている情報」または「社内で広く共有される一般的な業務文書」ですか？
      </div>
      <div className="arrow">→ はい</div>
      <div className="box green">
        【グリーン:申請不要で入力可】<br />
        通常通りAIを活用してください。
      </div>
      <div className="arrow">→ どちらとも言えない</div>
      <div className="box yellow">
        【判断保留】<br />
        上長またはセキュリティ担当に確認してください。<br />
        「確信が持てない場合は上長に確認する」文化を浸透させることが重要です。
      </div>

      <div className="box">
        イエロー判定時の承認フロー<br />
        承認ライン: 申請者 → 直属上長(第一承認) → 情報セキュリティ管理者または部門長(第二承認)<br />
        第一承認: 業務上の必要性確認<br />
        第二承認: 情報セキュリティ上のリスク評価<br />
        ※小規模組織では兼任も可能
      </div>
    </div>
      </>
    ),
  },
  {
    key: 'contact',
    label: '利用ポリシー',
    content: (
      <>
 <h2>AI利用ポリシー（第1条〜第6条）</h2>

      <div className="article">
        <h3>第1条 (定義)</h3>
        <ol>
          <li>「AIツール」：機械学習を活用し、文章生成・コード生成・画像生成・データ分析等を行うソフトウェア・クラウドサービス。</li>
          <li>「入力データ」：社員等がAIツールに入力または送信する文字・数値・画像等の情報。</li>
          <li>「出力データ」：AIツールが生成または返答した文章・コード・画像等の情報。</li>
          <li>「個人情報」：個人情報保護法第2条第1項に定める個人情報。</li>
          <li>「AI管理責任者」：本ポリシーの運用管理・改定を担当する責任者として経営層が指名した者。</li>
        </ol>
      </div>

      <div className="article">
        <h3>第2条 (利用可能なAIツール)</h3>
        <ol>
          <li>業務で利用するAIツールは会社が承認したもののみ。</li>
          <li>承認AIツールは別紙「承認AIツール一覧」に記載し、AI管理責任者が管理・更新。</li>
          <li>承認されていないツールを利用する場合は、事前にAI管理責任者へ申請し承認を得ること。</li>
        </ol>
      </div>

      <div className="article">
        <h3>第3条 (情報分類と入力ルール)</h3>
        <ol>
          <li>
            入力データは以下の3分類とする：<br />
            <ul>
              <li>[グリーン] 入力可・申請不要：公開情報や一般的な業務文書。</li>
              <li>[イエロー] 入力可・承認要：社外秘文書（個人情報を含まないもの、または匿名化済みデータ）。</li>
              <li>[レッド] 入力禁止：個人情報、NDA対象情報、未公開財務情報、人事情報、特許申請前技術情報。</li>
            </ul>
          </li>
          <li>イエロー情報を入力する場合は「AIツール利用申請書」に記入し承認を得ること。</li>
          <li>承認記録は申請日から1年間保管。</li>
        </ol>
      </div>

      <div className="article">
        <h3>第4条 (出力の取り扱い)</h3>
        <ol>
          <li>AI出力を対外文書や意思決定に利用する場合は、人間が正確性・適切性を確認すること。</li>
          <li>対外利用時は相手方や業界慣行を踏まえ、必要に応じてAI利用の事実を開示すること。</li>
          <li>AI出力をそのまま成果物として提出せず、専門的判断を加えて活用すること。</li>
        </ol>
      </div>

      <div className="article">
        <h3>第5条 (禁止行為)</h3>
        <ul>
          <li>個人情報（レッド分類）を承認なく入力すること。</li>
          <li>NDA対象情報を入力すること。</li>
          <li>未公開財務情報・未公表戦略を入力すること。</li>
          <li>差別的・違法・反社会的コンテンツの生成。</li>
          <li>私的目的での利用。</li>
          <li>承認されていないAIツールの業務利用。</li>
          <li>他者のAPIキーを無断使用。</li>
          <li>AI出力を事実確認なく重要意思決定や対外文書に使用。</li>
        </ul>
      </div>

      <div className="article">
        <h3>第6条 (APIキーの管理)</h3>
        <ol>
          <li>APIキーの発行・管理はAI管理責任者が一元的に行う。</li>
          <li>部門・用途ごとに分割管理し、個人アカウントでの管理は禁止。</li>
          <li>少なくとも数か月ごとにAPIキーを更新。</li>
          <li>ソースコードやドキュメントに直接記載することを禁止。</li>
        </ol>
      </div>
      </>
    ),
  },
];

function App() {
  const [activeKey, setActiveKey] = useState(menuItems[0].key);
  const [menuOpen, setMenuOpen] = useState(false);
  const activeItem = menuItems.find((item) => item.key === activeKey) || menuItems[0];

  return (
    <div className="App">
      <header className="site-header">
        <div className="brand">セキュリティ</div>
        <button
          className={`hamburger ${menuOpen ? 'open' : ''}`}
          onClick={() => setMenuOpen((prev) => !prev)}
          aria-label="Toggle menu"
          aria-expanded={menuOpen}
        >
          <span />
          <span />
          <span />
        </button>
        <nav className={`site-nav ${menuOpen ? 'open' : ''}`}>
          <ul>
            {menuItems.map((item) => (
              <li key={item.key}>
                <button
                  className={item.key === activeKey ? 'active' : ''}
                  onClick={() => {
                    setActiveKey(item.key);
                    setMenuOpen(false);
                  }}
                >
                  {item.label}
                </button>
              </li>
            ))}
          </ul>
        </nav>
      </header>
      <main className="page-body">{activeItem.content}</main>
    </div>
  );
}

export default App;
